var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"active":_vm.active,"dismissable":false,"title":"Update required"},on:{"dismiss":_vm.dismiss}},[_c('modal-body',[_c('p',[_vm._v("The portal has been updated and must be reloaded in order to continue.")])]),_vm._v(" "),_c('modal-actions',[_c('btn',{attrs:{"primary":""},on:{"click":_vm.onReload}},[_vm._v("Reload")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }